import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items, light = false }: { items: BreadcrumbItem[]; light?: boolean }) {
  const base = light ? "text-background-100/80" : "text-foreground-500";
  const linkHover = light ? "hover:text-accent-300" : "hover:text-accent-600";
  const current = light ? "text-background-50" : "text-foreground-800";
  const separator = light ? "text-background-100/40" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-2 text-xs md:text-sm ${base}`}>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className={`transition-colors ${linkHover}`}>
              {item.label}
            </Link>
          ) : (
            <span className={current}>{item.label}</span>
          )}
          {index < items.length - 1 && <i className={`ri-arrow-right-s-line text-base ${separator}`} />}
        </span>
      ))}
    </nav>
  );
}